<template>
  <div class="main-wrapper student-billing">
    <div class="container">
      <div class="invoice-wrapper download_section">
        <div class="inv-content">
          <div class="invoice-header">
            <div class="inv-header-left">
              <a href="javascript:;">
                <img src="@/assets/img/logo2.png" alt="Logo" />
              </a>
            </div>
            <div class="inv-header-right">
              <h2>UNIVERSITY NAME</h2>
            </div>
          </div>
          <div class="flight-invoice-details">
            <h3>Tax Invoice</h3>
            <div class="invoice-infomation">
              <div>Student Name : <span>Walter Roberson</span></div>
              <div>Student ID : <span>DD465123</span></div>
              <div>Term : <span>Winter</span></div>
            </div>
            <div class="invoice-infomation mb-0">
              <div>Balance Due : <span>$1815</span></div>
              <div>Due Date <span>05/01/2023</span></div>
              <div>Statement For : <span>2023 Spring</span></div>
            </div>
          </div>

          <div class="invoice-address">
            <div class="invoice-to">
              <span>Bill To:</span>
              <div class="inv-to-address">
                Walter Roberson<br />
                299 Star Trek Drive, Panama City, <br />
                Florida, 32405, USA.<br />
                walter@example.com <br />
                +45 5421 4523
              </div>
            </div>
          </div>
          <div class="invoice-table">
            <div class="table-responsive">
              <table>
                <thead>
                  <tr>
                    <th class="table_width_2">Details</th>
                    <th class="">Due Date</th>
                    <th class="text-end">Total</th>
                  </tr>
                </thead>
                <tbody>
                  <tr>
                    <td class="table-description">Semester Fee</td>
                    <td class="">28 March 2022</td>
                    <td class="text-end">$350</td>
                  </tr>
                  <tr>
                    <td class="table-description">Exam Fee</td>
                    <td class="">28 March 2022</td>
                    <td class="text-end">$600</td>
                  </tr>
                  <tr>
                    <td class="table-description">Transport Fee</td>
                    <td class="">28 March 2022</td>
                    <td class="text-end">$400</td>
                  </tr>
                  <tr>
                    <td class="table-description">Hostel Fee</td>
                    <td class="">28 March 2022</td>
                    <td class="text-end">$300</td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
          <div class="invoice-table-footer discount-table">
            <div class="table-footer-left notes">
              <span>Important Note:</span>
              <div class="delivery-notes">
                Delivery dates are not guaranteed and Seller has no liability for damages
                that may be incurred due to any delay.
              </div>
            </div>
            <div class="text-end table-footer-right">
              <table>
                <tbody>
                  <tr>
                    <td>Taxable Amount</td>
                    <td>$1650.00</td>
                  </tr>
                  <tr>
                    <td>Discount</td>
                    <td>+ $0.00</td>
                  </tr>
                  <tr>
                    <td>GST 18.0%</td>
                    <td>$165.00</td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
          <div class="invoice-table-footer payable-table">
            <div class="table-footer-left notes">
              <span>Total amount ( in words):</span> USD One Thousand Eight Hundred
              Fifteen Only.
            </div>
            <div class="text-end table-footer-right amount-payable">
              <table>
                <tbody>
                  <tr>
                    <td class="invoice-title">Amount Payable</td>
                    <td class="invoice-title">$1815.00</td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
          <div class="bank-details">
            <div class="payment-info">
              <span class="payment-title">Payment Info:</span>
              <div><span>Debit Card :</span> 465 *************645</div>
              <div><span>Amount :</span> $1,815</div>
            </div>
            <div class="company-sign">
              <span>For Dreamguys</span>
              <img src="@/assets/img/signature.png" alt="" />
            </div>
          </div>
          <div class="terms-condition">
            <span>Terms and Conditions:</span>
            <p>
              Here we can write a additional notes for the client to get a better
              understanding of this invoice.
            </p>
          </div>
          <div class="thanks-msg text-center">Thanks for your Business</div>
        </div>
      </div>
      <div class="file-link">
        <button class="download_btn download-link">
          <i class="feather-download-cloud me-1"></i> <span>Download</span>
        </button>
        <a href="javascript:window.print()" class="print-link">
          <i class="feather-printer"></i> <span class="">Print</span>
        </a>
      </div>
    </div>
  </div>
</template>
